<template>
  <div class="key-indicator">
    <detail-section title="关键指标">
      <el-row>
        <el-col v-for="item in keyList" :key="item.label" :span="6">
          <div class="key-indicator-item" @click="handleLink(item.route)">
            <div class="left-img">
              <img :src="frame" />
            </div>
            <div class="right-text">
              <div class="item-tit">{{ item.label }}</div>
              <div class="item-num">{{ numObj[item.value] }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </detail-section>
  </div>
</template>

<script>
import frame from '@/assets/images/blockChain/frame.png'

export default {
  name: 'KeyIndicator',
  data() {
    return {
      frame,
      keyList: [
        { label: '累计交易数', value: 'transactionNum', route: 'transactionInfo' },
        { label: '最新区块高度', value: 'blockHeight', route: 'blockInfo' },
        { label: '链上节点 (单位:个)', value: 'nodeNum', route: 'nodeInfo' },
        { label: '链上组织数 (单位:个)', value: 'orgNum', route: 'organizationInfo' }
      ],
      numObj: {}
    }
  },
  mounted() {
    let cid = this.$route.query.chainId
    this.getData(cid)
  },
  methods: {
    getData(cid) {
      if (cid) {
        this.$apis.home.getOverview({ cid }).then(res => {
          if (res.data) {
            this.numObj = res.data
          }
        })
      }
    },
    handleLink(link) {
      this.$router.push({
        name: link
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'key-indicator',
  (
    --key-indicator-item-background-color: #303c65,
    --key-indicator-item-tit-color: #a3afb5,
    --key-indicator-item-num-color: #fff
  ),
  (
    --key-indicator-item-background-color: #ebebeb,
    --key-indicator-item-tit-color: #5A6973,
    --key-indicator-item-num-color: #192227
  )
);
.key-indicator {
  @include adaptation(
    (
      --key-indicator-row-margin: 0 -8px,
      --key-indicator-col-padding: 0 8px,
      --key-indicator-detail-section-padding: 4px 0,
      --key-indicator-detail-section-content-padding: 4px 0 12px,
      --key-indicator-item-border-radius: 4px,
      --key-indicator-item-height: 108px,
      --key-indicator-item-padding: 8px 8px 8px 30px,
      --key-indicator-item-img-size: 92px,
      --key-indicator-item-text-margin-left: 30px,
      --key-indicator-item-tit-font-size: 12px,
      --key-indicator-item-tit-line-height: 17px,
      --key-indicator-item-num-font-size: 26px,
      --key-indicator-item-num-line-height: 26px,
      --key-indicator-item-num-margin-top: 12px
    )
  );

  .el-row {
    margin: var(--key-indicator-row-margin);
    .el-col {
      padding: var(--key-indicator-col-padding);
    }
  }

  .cbaas-detail-section {
    padding: var(--key-indicator-detail-section-padding);
    /deep/ .content {
      padding: var(--key-indicator-detail-section-content-padding);
    }
  }

  .key-indicator-item {
    border-radius: var(--key-indicator-item-border-radius);
    background: var(--key-indicator-item-background-color);
    display: flex;
    align-items: center;
    width: 100%;
    height: var(--key-indicator-item-height);
    padding: var(--key-indicator-item-padding);

    .left-img {
      img {
        width: var(--key-indicator-item-img-size);
        height: var(--key-indicator-item-img-size);
      }
    }

    .right-text {
      display: flex;
      flex-direction: column;
      margin-left: var(--key-indicator-item-text-margin-left);

      .item-tit {
        color: var(--key-indicator-item-tit-color);
        font-size: var(--key-indicator-item-tit-font-size);
        font-weight: 350;
        line-height: var(--key-indicator-item-tit-line-height);
        height: var(--key-indicator-item-tit-line-height);
      }

      .item-num {
        color: var(--key-indicator-item-num-color);
        font-size: var(--key-indicator-item-num-font-size);
        font-weight: 500;
        margin-top: var(--key-indicator-item-num-margin-top);
        line-height: var(--key-indicator-item-num-line-height);
        height: var(--key-indicator-item-num-line-height);
      }
    }
  }
}
</style>
